import React from "react";
import LoginContainer from "../../containers/Auth/Login";

export default function LoginPage() {
  return <LoginContainer />;
}
